"use strict";

import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import classNames from "classnames";
import React, { Component, createRef, cloneElement, Children } from "react";
import { createPortal } from "react-dom";
import { action, observable, computed } from "mobx";
import { observer } from "mobx-react";
import { Transition } from "react-transition-group";
import forceReflow from "../../../utils/forceReflow";
import getPortalRoot from "../../../utils/getPortalRoot";
import { randomString, shouldUpdatePosition } from "../../../utils";
import getOverlayPosition from "../../../utils/getOverlayPosition";
import observeRect from "@reach/observe-rect";
import { isEqual } from "lodash";
import { Layer } from "../../../utils/layers/LayerContext";
import * as styles from "./Tooltip-css";
import { darkTheme, duration, lightTheme } from "../../../tokens/tokens-css";
import { assignInlineVars } from "@vanilla-extract/dynamic";
export var TooltipSize = /* @__PURE__ */function (TooltipSize2) {
  TooltipSize2["Small"] = "small";
  TooltipSize2["Large"] = "large";
  return TooltipSize2;
}(TooltipSize || {});
export var TooltipPosition = /* @__PURE__ */function (TooltipPosition2) {
  TooltipPosition2["Top"] = "top";
  TooltipPosition2["Bottom"] = "bottom";
  TooltipPosition2["Left"] = "left";
  TooltipPosition2["Right"] = "right";
  return TooltipPosition2;
}(TooltipPosition || {});
var Tooltip = /*#__PURE__*/function (_Component) {
  _inherits(Tooltip, _Component);
  var _super = _createSuper(Tooltip);
  function Tooltip() {
    var _this;
    _classCallCheck(this, Tooltip);
    _this = _super.apply(this, arguments);
    _this.targetRef = createRef();
    _this.portalRoot = getPortalRoot("tooltip-root");
    _this.id = randomString();
    _this.show = false;
    _this.handleEnter = function (event, handleEvent) {
      handleEvent == null ? void 0 : handleEvent(event);
      _this.show = true;
    };
    _this.handleLeave = function (event, handleEvent) {
      handleEvent == null ? void 0 : handleEvent(event);
      _this.show = false;
    };
    _this.handleKeyDown = function (event, handleEvent) {
      handleEvent == null ? void 0 : handleEvent(event);
      if (event.key === "Escape") {
        _this.show = false;
      }
    };
    return _this;
  }
  _createClass(Tooltip, [{
    key: "render",
    value: function render() {
      var _this2 = this,
        _targetProps;
      var _this$props = this.props,
        content = _this$props.content,
        size = _this$props.size,
        children = _this$props.children,
        className = _this$props.className,
        wrapTarget = _this$props.wrapTarget,
        targetClassName = _this$props.targetClassName,
        position = _this$props.position,
        offset = _this$props.offset,
        isError = _this$props.isError,
        style = _this$props.style,
        theme = _this$props.theme;
      var show = (this.isControlledTooltip ? this.props.show : this.show) && !!this.targetRef.current;
      var tooltipId = "tooltip-".concat(this.id);
      var child = wrapTarget ? null : Children.only(children);
      var targetProps = (_targetProps = {}, _defineProperty(_targetProps, "aria-describedby", show ? tooltipId : void 0), _defineProperty(_targetProps, "tabIndex", isError ? void 0 : 0), _defineProperty(_targetProps, "onFocus", function onFocus(event) {
        return _this2.handleEnter(event, child == null ? void 0 : child.props.onFocus);
      }), _defineProperty(_targetProps, "onBlur", function onBlur(event) {
        return _this2.handleLeave(event, child == null ? void 0 : child.props.onBlur);
      }), _defineProperty(_targetProps, "onMouseEnter", function onMouseEnter(event) {
        return _this2.handleEnter(event, child == null ? void 0 : child.props.onMouseEnter);
      }), _defineProperty(_targetProps, "onMouseLeave", function onMouseLeave(event) {
        return _this2.handleLeave(event, child == null ? void 0 : child.props.onMouseLeave);
      }), _defineProperty(_targetProps, "onKeyDown", function onKeyDown(event) {
        return _this2.handleKeyDown(event, child == null ? void 0 : child.props.onKeyDown);
      }), _targetProps);
      return /* @__PURE__ */React.createElement("div", {
        className: classNames("kl-tooltip-target", targetClassName),
        ref: this.targetRef
      }, /* @__PURE__ */React.createElement(Transition, {
        mountOnEnter: true,
        unmountOnExit: true,
        in: show,
        timeout: duration.m,
        onEnter: forceReflow
      }, function (status) {
        return createPortal( /* @__PURE__ */React.createElement(Layer, null, function (_ref) {
          var zIndex = _ref.zIndex;
          return /* @__PURE__ */React.createElement(TooltipElement, {
            id: tooltipId,
            targetRef: _this2.targetRef,
            position: position,
            size: size,
            onMouseEnter: _this2.isControlledTooltip ? _this2.handleEnter : void 0,
            onMouseLeave: _this2.isControlledTooltip ? _this2.handleLeave : void 0,
            className: classNames(className),
            theme: theme,
            transitionStatus: status,
            offset: offset,
            isError: isError,
            style: __spreadValues({
              zIndex: _this2.props.autoStack ? zIndex : void 0
            }, style)
          }, content);
        }), _this2.portalRoot);
      }), child == null ? /* @__PURE__ */React.createElement("div", __spreadValues({
        className: classNames("kl-tooltip-target__wrapper", styles.wrapper)
      }, targetProps), children) : cloneElement(child, targetProps));
    }
  }, {
    key: "isControlledTooltip",
    get: function get() {
      return this.props.show !== void 0 && this.props.show !== null;
    }
  }]);
  return Tooltip;
}(Component);
Tooltip.defaultProps = {
  size: "small" /* Small */,
  position: "top" /* Top */,
  offset: 4
};
__decorateClass([observable.shallow], Tooltip.prototype, "targetRef", 2);
__decorateClass([observable], Tooltip.prototype, "show", 2);
__decorateClass([action], Tooltip.prototype, "handleEnter", 2);
__decorateClass([action], Tooltip.prototype, "handleLeave", 2);
__decorateClass([action], Tooltip.prototype, "handleKeyDown", 2);
__decorateClass([computed], Tooltip.prototype, "isControlledTooltip", 1);
Tooltip = __decorateClass([observer], Tooltip);
export { Tooltip as default };
export var TooltipElement = /*#__PURE__*/function (_Component2) {
  _inherits(TooltipElement, _Component2);
  var _super2 = _createSuper(TooltipElement);
  function TooltipElement(props) {
    var _this3;
    _classCallCheck(this, TooltipElement);
    var _a;
    _this3 = _super2.call(this, props);
    _this3.tooltipRef = createRef();
    _this3.caretSize = 8;
    _this3.handleRectObserver = function (targetRect) {
      var _a;
      if (!targetRect || !shouldUpdatePosition(targetRect)) return;
      var _this3$props = _this3.props,
        position = _this3$props.position,
        offset = _this3$props.offset;
      var overlayRect = (_a = _this3.tooltipRef.current) == null ? void 0 : _a.getBoundingClientRect();
      _this3.tooltipPosition = getOverlayPosition({
        position: position,
        offset: offset,
        targetRect: targetRect,
        overlayRect: overlayRect,
        caretSize: _this3.caretSize,
        outerMargin: 4
      });
    };
    _this3.onMouseDown = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
    _this3.tooltipRef = (_a = props.forwardRef) != null ? _a : createRef();
    return _this3;
  }
  _createClass(TooltipElement, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _a;
      if ((_a = this.props.targetRef) == null ? void 0 : _a.current) {
        this.rectObserver = observeRect(this.props.targetRef.current, this.handleRectObserver);
        this.rectObserver.observe();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _a;
      if (!isEqual(prevProps, this.props) && ((_a = this.props.targetRef) == null ? void 0 : _a.current)) {
        this.handleRectObserver(this.props.targetRef.current.getBoundingClientRect());
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _a;
      (_a = this.rectObserver) == null ? void 0 : _a.unobserve();
    }
  }, {
    key: "render",
    value: function render() {
      var _assignInlineVars, _classNames, _assignInlineVars3;
      var _a;
      var _this$props2 = this.props,
        id = _this$props2.id,
        style = _this$props2.style,
        size = _this$props2.size,
        className = _this$props2.className,
        children = _this$props2.children,
        onMouseEnter = _this$props2.onMouseEnter,
        onMouseLeave = _this$props2.onMouseLeave,
        transitionStatus = _this$props2.transitionStatus,
        position = _this$props2.position,
        isError = _this$props2.isError,
        theme = _this$props2.theme;
      var positionModifier = ((_a = this.tooltipPosition) == null ? void 0 : _a.modifier) || position;
      return /* @__PURE__ */React.createElement("div", {
        "aria-live": "polite",
        id: id,
        ref: this.tooltipRef,
        style: __spreadValues(__spreadValues({}, style), this.tooltipPosition ? assignInlineVars((_assignInlineVars = {}, _defineProperty(_assignInlineVars, styles.top, "".concat(this.tooltipPosition.overlay.top, "px")), _defineProperty(_assignInlineVars, styles.left, "".concat(this.tooltipPosition.overlay.left, "px")), _assignInlineVars)) : {}),
        contentEditable: false,
        className: classNames("kl-tooltip", "kl-tooltip--".concat(positionModifier), "kl-tooltip--".concat(size), "kl-tooltip--".concat(transitionStatus), styles.tooltip({
          position: position,
          status: transitionStatus,
          error: isError,
          size: size
        }), className, (_classNames = {}, _defineProperty(_classNames, lightTheme, theme === "light"), _defineProperty(_classNames, darkTheme, !theme || theme === "dark"), _classNames)),
        role: isError ? "alert" : "tooltip",
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseDown: this.onMouseDown
      }, /* @__PURE__ */React.createElement("div", {
        className: classNames("kl-tooltip__caret", "kl-tooltip__caret--".concat(positionModifier), styles.caret({
          position: positionModifier
        })),
        style: __spreadValues(__spreadValues({}, assignInlineVars(_defineProperty({}, styles.caretSize, "".concat(this.caretSize, "px")))), this.tooltipPosition ? assignInlineVars((_assignInlineVars3 = {}, _defineProperty(_assignInlineVars3, styles.caretTop, "".concat(this.tooltipPosition.caret.top, "px")), _defineProperty(_assignInlineVars3, styles.caretLeft, "".concat(this.tooltipPosition.caret.left, "px")), _assignInlineVars3)) : {})
      }), /* @__PURE__ */React.createElement("div", {
        className: classNames("kl-tooltip__content", styles.content({
          size: size
        }))
      }, children));
    }
  }]);
  return TooltipElement;
}(Component);
TooltipElement.defaultProps = {
  transitionStatus: "entered"
};
__decorateClass([observable.ref], TooltipElement.prototype, "tooltipPosition", 2);
__decorateClass([action], TooltipElement.prototype, "handleRectObserver", 2);
TooltipElement = __decorateClass([observer], TooltipElement);